import utils from 'utils'

/**
 * 编辑和保存公用
 * 编辑时编号不能修改
 */
class goodsInfoEditCtrl {
    constructor($scope, $http, httpRequest, $state, formvalidateApi, $timeout) {
        // 初始化表单数据
        const {
            goodsId
        } = $state.params
        $scope.isEdit = goodsId
        $scope.goodsCodeIsDisable = true
        httpRequest.get_dictByTypeArr(['is_privilege', 'levy_way']).then((res) => {
            $scope.dictData = res.data.value
            $scope.dictData.is_privilege.forEach((i) => i.enumCode = +i.enumCode)
        })
        httpRequest.get_getLoginUserGoodsTypeList(0).then((res) => {
            $scope.goodsTypeList = res.data.value
            $scope.goodsInfoForm.typeId = $scope.goodsTypeList[0].typeId
        })
        // 初始化表单数据
        $scope.goodsInfoForm = {
            isPrivilege: 0,
            levyWay: '1',
            orgId: JSON.parse(localStorage.user_info).user.currentOrgId,
            privilegeType: '', // 这一行不能删
            status: 1,
            taxInclud: 1,
            taxRate: 0,
            typeId: 0,
        }
        // 是否享用优惠政策
        $scope.isPrivilegeFlag = true

        // 税分合并编码获取的数据
        $scope.taxClassInfo = {
            taxName: '',
            codeVersions: '',
            taxRateList: [],
            discountOptionList: [],
            taxSpecialManageList: [],
        }

        // 自动编码
        $scope.goodsCodeAutoSetting = function goodsCodeAutoSetting(val) {
            $scope.goodsCodeIsDisable = val
            if (val) {
                $scope.goodsInfoForm.goodsCode = null
            }
        }
        $scope.taxRateOptions = []
        // 获取商品税率
        function getTaxRateOptions() {
            const rateReq = {
                taxMergeCode: $scope.goodsInfoForm.taxMergeCode,
                privilegeType: encodeURIComponent($scope.goodsInfoForm.privilegeType || ''),
                invType: -1,
            }
            return httpRequest.get_qryGoodsInfoTax(rateReq).then((res) => {
                $scope.taxRateOptions = res.data.value
            })
        }

        function setTaxRate() {
            if ($scope.goodsInfoForm.isPrivilege === 1) {
                $scope.goodsInfoForm.taxRate = $scope.taxRateOptions[0]
            } else {
                $scope.goodsInfoForm.taxRate = $scope.taxClassInfo.taxRateList[0]
            }
        }


        // 获取数据
        if ($scope.isEdit) {
            httpRequest.get_qryGoodsInfo(goodsId).then((res) => {
                $scope.goodsInfoForm = $.extend({}, $scope.goodsInfoForm, res.data.value)
                // 优惠政策类型无不能编辑需求
                if ($scope.goodsInfoForm.isPrivilege === 0) {
                    $scope.isPrivilegeFlag = true
                } else {
                    $scope.isPrivilegeFlag = false
                }
                // $scope.taxClassInfo = $scope.goodsInfoForm
                $scope.goodsInfoForm.taxMergeCode1 = $scope.goodsInfoForm.taxMergeCode
                // $scope.qryTaxClassInfo()
                $http.get(`${host.etcloudOvat}settings/sysGoodsInfo/qryTaxClassInfo?taxMergeCode=${$scope.goodsInfoForm.taxMergeCode}`).then((res) => {
                    $scope.taxClassInfo = res.data.value
                    $scope.goodsInfoForm.taxShortName = $scope.taxClassInfo.taxShortName
                    getTaxRateOptions()
                })
            })
        }
        /**
         * 当商品享受不征税，且税率为0税率锁定
         * @param  {object}  taxClassInfo 税分编码信息
         */
        function isTaxClassLocked(taxClassInfo) {
            const {
                taxSpecialManageList
            } = taxClassInfo
            if (taxSpecialManageList.length === 1 &&
                taxSpecialManageList[0] === '不征税' &&
                taxClassInfo.taxRateList[0] === 0) {
                return true
            }
            return false
        }
        /**
         * 选择税收分类后回调
         */
        $scope.qryTaxClassInfo = function qryTaxClassInfo() {
            $timeout(() => {
                $scope.goodsInfoForm.taxMergeName = $scope.taxClassInfo.taxName
                $scope.goodsInfoForm.codeVersions = $scope.taxClassInfo.codeVersions
                $scope.goodsInfoForm.taxMergeCode = $scope.taxClassInfo.mergeCode
                $scope.goodsInfoForm.taxMergeCode1 = $scope.taxClassInfo.mergeCode
                $scope.goodsInfoForm.taxShortName = $scope.taxClassInfo.taxShortName
                if (!($scope.taxClassInfo.discountOptionList && $scope.taxClassInfo.discountOptionList.length < 2)) {
                    $scope.goodsInfoForm.isPrivilege = 0
                    $scope.goodsInfoForm.taxRate = $scope.taxClassInfo.taxRateList[0]
                    $scope.isPrivilegeFlag = true
                    $scope.goodsInfoForm.privilegeType = ''
                } else {
                    $scope.goodsInfoForm.isPrivilege = 1
                    $scope.isPrivilegeFlag = false
                    $scope.goodsInfoForm.privilegeType = $scope.taxClassInfo.taxSpecialManageList[0]
                }
                $scope.isTaxClassLocked = isTaxClassLocked($scope.taxClassInfo)
                // 强制不征税且税率为0
                if ($scope.isTaxClassLocked) {
                    $scope.goodsInfoForm.isPrivilege = 1
                    $scope.goodsInfoForm.privilegeType = $scope.taxClassInfo.taxSpecialManageList[0]
                    $scope.goodsInfoForm.taxRate = 0
                    $scope.taxRateOptions = [0]
                } else {
                    getTaxRateOptions().then(setTaxRate)
                }
            })
        }

        // 是否享受优化政策
        $scope.changeIsPrivilege = function changeIsPrivilege() {
            if ($scope.goodsInfoForm.isPrivilege === 0) {
                $scope.isPrivilegeFlag = true
                $scope.goodsInfoForm.privilegeType = ''
            } else {
                $scope.goodsInfoForm.privilegeType = $scope.taxClassInfo.taxSpecialManageList[0]
                $scope.isPrivilegeFlag = false
            }
            getTaxRateOptions().then(setTaxRate)
        }

        // 优惠政策变化
        $scope.changePrivilegeType = function changePrivilegeType() {
            getTaxRateOptions().then(setTaxRate)
        }

        // 规则
        $scope.validateRules = {
            price: [{
                erromsg: '单价为正数，最大值100000000000000（15位）',
                condition(value) {
                    // 规则
                    return !(value == null || value === '' || (Number(value) > 0 && (lengthForString(value.toString()) < 15)))
                },
            }],
            goodsCode: [{
                erromsg: '2~32个字符，字母或数字',
                condition(value) {
                    if (value === null || value === undefined) {
                        value = ''
                    }
                    const reg = /^[0-9A-Za-z]{2,32}$/
                    // 规则
                    return $scope.goodsCodeIsDisable ? false : !reg.test(value)
                },
            }],
            goodsName: [{
                erromsg: '最多92个字符',
                condition(value) {
                    // 规则
                    return (lengthForString(value.toString()) > 92)
                },
            }],
            isPrivilegeFlag: [{
                erromsg: '请选择优惠政策类型',
                condition(value) {
                    return $scope.goodsInfoForm.isPrivilege === 1 && !value
                },
            }],
            specifications: [{
                erromsg: '商品规格型号1-40个字符',
                condition(value) {
                    // 规则
                    return !((value == '' || value == null) || (lengthForString(value.toString()) < 40))
                },
            }],
            measureUnit: [{
                erromsg: '计量单位最多32个字符',
                condition(value) {
                    // 规则
                    return !((value == '' || value == null) || (lengthForString(value.toString()) < 32))
                },
            }]
        }
        const submitHandler = {
            edit() {
                httpRequest.post_modGoodsInfo($scope.goodsInfoForm, '编辑成功').then(() => {
                    $state.go('outputManage.ovat.goodsInfo.list')
                }, () => {
                    $scope.adding = false
                })
            },
            add() {
                httpRequest.post_addGoodsInfo($scope.goodsInfoForm, '新增成功').then(() => {
                    $state.go('outputManage.ovat.goodsInfo.list')
                }, () => {
                    $scope.adding = false
                })
            },
        }
        $scope.adding = false
        // 编辑保存
        $scope.submitgoodsInfoForm = function () {
            if ($scope.adding) {
                return
            }
            const ret = formvalidateApi.run()
            $scope.adding = true
            if (ret) {
                if ($scope.isEdit) {
                    submitHandler.edit()
                } else {
                    submitHandler.add()
                }
            } else {
                $scope.adding = false
            }
        }
        // 返回
        $scope.cancelgoodsInfoForm = function () {
            $state.go('outputManage.ovat.goodsInfo.list')
            return false
        }

        function lengthForString(temp) {
            let len = 0
            temp = $.trim(temp)
            for (let i = 0; i < temp.length; i += 1) {
                const c = temp.charCodeAt(i)
                // 单字节加1
                if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
                    len += 1
                } else {
                    len += 2
                }
            }
            return len
        }
        $scope.$watch('goodsInfoForm.taxMergeCode1', (newVal, oldVal) => {
            if (!newVal || newVal === oldVal) {
                return
            }
            if (utils.isRefinedOil(newVal) && !$scope.validateRules.measureUnit) {
                $scope.validateRules.measureUnit = [{
                    erromsg: '成品油商品，计量单位必为“吨”或“升”',
                    condition(value) {
                        return !(value === '吨' || value === '升')
                    },
                }]
            } else {
                $scope.validateRules.measureUnit = [{
                    erromsg: '计量单位最多32个字符',
                    condition(value) {
                        // 规则
                        return !((value == '' || value == null) || (lengthForString(value.toString()) < 32))
                    },
                }]
            }
        })
    }
}
goodsInfoEditCtrl.$inject = ['$scope', '$http', 'httpRequest', '$state', 'formvalidateApi', '$timeout']
export default goodsInfoEditCtrl


// WEBPACK FOOTER //
// ./src/app/outputManage/baseData/goodsInfo/goodsInfoEditCtrl.js